import { isRef, onScopeDispose, watch, type Ref } from 'vue';
import { hideAllPoppers } from 'floating-vue';
import { throttle } from '../helpers/throttle';

type PlainTarget = HTMLElement | Document;
type ReactiveTarget = Ref<HTMLElement | null | undefined>;
type EmptyTarget = null | undefined;

// Используйте если нужно отключить видимость тултипов сразу пачкой(по дефолту все активные тултипы пакета floating-vue) при возникновении события dom.
// Иначе тултипы могут выходить за рамки родительских контейнеров и отображаться там где не нужно(по дефолту floating-vue рендер в body и высокий z-index)
// Настройки через пропс container пакета floating-vue, либо другие, не всегда приемлемы.
// Например при использовании атомарных компонентов или виджетов(используют floating-vue) из frontend-apps\libs
// стараемся не использовать специфичные для конкретного пакета пропсы
// То есть предполагается, что может быть замена floating-vue в пользу нативного решения,
// а если так произойдёт, можно будет удалить этот файл.

export const useHideAllTooltipsOnEvent = (
    target: ReactiveTarget | PlainTarget | EmptyTarget,
    eventType: keyof HTMLElementEventMap,
    // логика отключения видимости тултипов
    callback?: () => void
) => {
    if (!target) {
        console.error('Target is null or undefined');
        return;
    }

    let htmlElement: PlainTarget | EmptyTarget = null;

    const throttledCallback = throttle(() => {
        hideAllPoppers();
        if (callback) callback();
    });

    if (isRef(target)) {
        const unwatch = watch(target, (value) => {
            htmlElement = value;
            htmlElement!.addEventListener(eventType, throttledCallback);
            unwatch();
        });
    } else {
        htmlElement = target;
        htmlElement.addEventListener(eventType, throttledCallback);
    }

    onScopeDispose(() => {
        if (htmlElement) htmlElement.removeEventListener(eventType, throttledCallback);
    });
};
